import { render } from "./AgentSection.vue?vue&type=template&id=939885b8&scoped=true"
import script from "./AgentSection.vue?vue&type=script&lang=js"
export * from "./AgentSection.vue?vue&type=script&lang=js"

import "./AgentSection.vue?vue&type=style&index=0&id=939885b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-939885b8"]])

export default __exports__